import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6","key":"svg-0"}],["path",{"d":"M7 9l11 0","key":"svg-1"}]]

const IconCurrencyRupee = createReactComponent('outline', 'currency-rupee', 'CurrencyRupee', __iconNode);

export default IconCurrencyRupee;